/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Style_Save_ButtonInputs */



/**
* | output |
* | --- |
* | "Save" |
*
* @param {Image_Export_Style_Save_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_style_save_button = /** @type {((inputs?: Image_Export_Style_Save_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Style_Save_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранять")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ahorrar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("节省")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बचाना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar")
	return /** @type {LocalizedString} */ ("Save")
});